/**
 * i18n helper
 *
 * Cách dùng đơn giản (không cần library):
 *
 *   import { t } from '@/lib/i18n';
 *
 *   // Static key
 *   t('common.loading')                          // → "Đang tải…"
 *
 *   // Template với params
 *   t('lobby.greeting', { name: 'Duc' })         // → "Xin chào, Duc!"
 *   t('roundsList.questions', { n: 10 })         // → "10 câu"
 *   t('common.page', { page: 2, total: 5 })      // → "Trang 2 / 5"
 */
import vi from './vi';

type Translations = typeof vi;

/** Lấy value từ nested object bằng dotted key, e.g. "common.loading" */
function getNestedValue(obj: Record<string, unknown>, key: string): string {
  const parts = key.split('.');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let current: any = obj;
  for (const part of parts) {
    if (current == null || typeof current !== 'object') return key;
    current = current[part];
  }
  return typeof current === 'string' ? current : key;
}

/** Thay thế {param} trong template string */
function interpolate(template: string, params?: Record<string, string | number>): string {
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (_, k) =>
    params[k] !== undefined ? String(params[k]) : `{${k}}`
  );
}

/**
 * Tra cứu text theo key và thay thế params.
 * @param key  - Dotted path vào object vi, e.g. "common.loading"
 * @param params - Tham số để điền vào template, e.g. { name: "Duc" }
 */
export function t(key: string, params?: Record<string, string | number>): string {
  const raw = getNestedValue(vi as unknown as Record<string, unknown>, key);
  return interpolate(raw, params);
}

/** Export toàn bộ object để dùng trực tiếp nếu cần */
export const i18n: Translations = vi;
export default vi;
